/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimResponseDto } from './ClaimResponseDto';
import {
    ClaimResponseDtoFromJSON,
    ClaimResponseDtoFromJSONTyped,
    ClaimResponseDtoToJSON,
    ClaimResponseDtoToJSONTyped,
} from './ClaimResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface ClaimPaginationResponseDto
 */
export interface ClaimPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof ClaimPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<ClaimResponseDto>}
     * @memberof ClaimPaginationResponseDto
     */
    items: Array<ClaimResponseDto>;
}

/**
 * Check if a given object implements the ClaimPaginationResponseDto interface.
 */
export function instanceOfClaimPaginationResponseDto(value: object): value is ClaimPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function ClaimPaginationResponseDtoFromJSON(json: any): ClaimPaginationResponseDto {
    return ClaimPaginationResponseDtoFromJSONTyped(json, false);
}

export function ClaimPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(ClaimResponseDtoFromJSON)),
    };
}

export function ClaimPaginationResponseDtoToJSON(json: any): ClaimPaginationResponseDto {
    return ClaimPaginationResponseDtoToJSONTyped(json, false);
}

export function ClaimPaginationResponseDtoToJSONTyped(value?: ClaimPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(ClaimResponseDtoToJSON)),
    };
}

